<script>
import lazyLoadComponent from '@router/lazyload-component'

export default {
	page: {
	},
	components: {
	},
	filters: {

	},

	props: {

	},
	data() {
		return {
			submitData: {}
		}
	},
	computed: {
		submitRules() { }
	},
	watch: {

	},
	created() {

	},
	methods: {
		toClick() { }
	},
}
</script>

<template>
	<div :class="$style.content">
		<el-form ref="form" :model="submitData" :rules="submitRules" label-position="top" class="el-form--floating">
			<el-row :gutter="20">
				<el-col :span="24">
					<div :class="$style.timeDisplay">
						<p>緩衝時間</p>
						<el-input v-model.number="submitData.bufferTime" class="bg-white is-border" type="number" min="0" />
						<p>小時候，每小時超時加價</p>
						<el-input v-model.number="submitData.bufferTime" class="bg-white is-border" type="number" min="0" />
						<p>元</p>
					</div>
					<p>緩衝時間請以0.5為單位</p>
				</el-col>
				<el-col :span="24">
					<el-form-item label="營業時間外CheckIn加價" prop="description">
						<el-input v-model.number="submitData.bufferTime" class="bg-white is-border" type="number" min="0" />
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="營業時間外Checkout加價" prop="description">
						<el-input v-model.number="submitData.bufferTime" class="bg-white is-border" type="number" min="0" />
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>

<style lang="scss" module>
.content {
	background-color: white;
	padding: 20px;
}

.timeDisplay {
	display: flex;
	align-items: center;

	p {
		flex-shrink: 0;
	}

	:global {
		.el-input {
			margin-left: 10px;
			margin-right: 10px;
		}
	}
}
</style>
